export const release = process.env.REACT_APP_GIT_SHA

// REACT_APP_VERSION is set by the start/build scripts. Importing package.json
// instead put the whole file, every dependency version included, into the
// public bundle.
export const version = `${process.env.REACT_APP_VERSION}-${release ?? 'develop'}`;
